import { useTranslation } from 'react-i18next'
import { useScopedAdminPath } from '@/shared/hooks/use-scoped-admin-path'
import { generatePath } from '@/shared/libs/generate-path'
import { FormPageActions } from '@/shared/ui/form-page-actions'
import { PageHeader } from '@/shared/ui/page-header'

interface FormHeaderProps {
  isEdit: boolean
  tenantId: string
  tenantName: string
  isSaving: boolean
  hasUnsavedChanges: boolean
  onBack: () => void
  onSubmit: () => void
}

/** Page title and breadcrumbs of the POI form. */
export function FormHeader({
  isEdit,
  tenantId,
  tenantName,
  isSaving,
  hasUnsavedChanges,
  onBack,
  onSubmit,
}: FormHeaderProps) {
  const { t } = useTranslation()
  const scopedAdminPath = useScopedAdminPath()
  const title = isEdit ? t('poi.edit') : t('poi.create')

  return (
    <PageHeader
      title={title}
      breadcrumbs={[
        { label: t('sidebar.tenants'), path: scopedAdminPath('/tenant') },
        {
          label: tenantName,
          path: scopedAdminPath(generatePath('/tenant/:tenantId', { tenantId })),
        },
        {
          label: t('poi.title'),
          path: scopedAdminPath(generatePath('/tenant/:tenantId/pois', { tenantId })),
        },
        { label: title },
      ]}
      actions={
        <FormPageActions
          isEdit={isEdit}
          isSaving={isSaving}
          canSubmit={hasUnsavedChanges}
          onBack={onBack}
          onSubmit={onSubmit}
        />
      }
    />
  )
}
